import images from './images';

const regulars = [
  {
    title: 'Hair Repair Treatment',
    price: '150K',
    tags: 'Treatment untuk rambut yang sudah rusak akibat bahan kimia yang berfungsi untuk mengembalikan kesehatan rambutmu ',
  },
  {
    title: 'Gentlemen Grooming',
    price: '60K',
    tags: 'Perawatan pria lengkap: mulai dari pembersihan wajah, potong rambut, hingga pijatan kepala dan aplikasi produk styling. ',
  },
  {
    title: 'Kids Haircut',
    price: '50K',
    tags: 'Pengalaman potong rambut yang ramah dan nyaman untuk si kecil. ',
  },
  {
    title: 'Grooming + Hair Tattoo',
    price: '140K',
    tags: 'Untuk kamu yang ingin mencari gaya rambut khas. Biarkan barberman kami yang terampil untuk membentuk dan merancang gaya rambut-mu seperti hasil mahakaryanya. ',
  },
  {
    title: 'Down perm',
    price: '150K',
    tags: 'Membuat rambut kamu terlihat lebih rata (tidak jigrak) dibagian samping',
  },
];

const premiums = [
  {
    title: 'Premium Grooming',
    price: '100K',
    tags: 'Dimulai dengan membersihkan wajah dengan handuk dingin kemudian potong rambut lalu keramas, selanjutnya membersihkan wajah dengan handuk hangat, mendapatkan pijat kepala, leher dan bahu lalu diakhiri dengan pengaplikasian tonic dan pomade untuk styling.',
  },
  {
    title: 'Hair Color',
    price: '300K',
    tags: 'Warnai rambutmu (tanpa dibleaching) dengan sempurna sesuai dengan warna idaman-mu dengan barberman kami yang sudah berpengalaman. ',
  },
  {
    title: "Smoothing",
    price: '350K',
    tags: 'Pelurusan rambut dengan hasil yang natural. ',
  },
  {
    title: 'Korean Perm',
    price: '350K',
    tags: 'Membuat rambut kamu terlihat lebih rata (tidak jigrak) dibagian samping (down perm) dan lebih bervolume juga berbentuk di bagian depan & atas rambut (root lift)',
  },
  {
    title: 'Hair Repair Treatment',
    price: '150K',
    tags: 'Treatment untuk rambut yang sudah rusak akibat bahan kimia yang berfungsi untuk mengembalikan kesehatan rambutmu ',
  },
];

const services = [
  {
    imgUrl: images.hairrepair,
    title: 'Hair Repair Treatment',
  },
  {
    imgUrl: images.gentle,
    title: 'Gentleman Grooming',
  },
  {
    imgUrl: images.kids,
    title: 'Kids Haircut',
  },
  {
    imgUrl: images.tatto,
    title: 'Hair Tatto',
  },
  {
    imgUrl: images.color,
    title: 'Fashion Hair Color',
  },
  {
    imgUrl: images.smooth,
    title: 'Smoothing Hair Treatment',
  },
  {
    imgUrl: images.perm,
    title: 'Perm Hair Treatment',
  },
];

const pricey = {
  regulars,
  premiums,
  services,
};

export default pricey;

// export default { regulars, premiums, services };